export default {
  get itinerariesApiUrl() {
    return process.env.VUE_APP_ITINERARY_ENDPOINT
  },
};
